import { render, staticRenderFns } from "./PetPackCard.vue?vue&type=template&id=097b7b61"
import script from "./PetPackCard.vue?vue&type=script&lang=js"
export * from "./PetPackCard.vue?vue&type=script&lang=js"
import style0 from "./PetPackCard.vue?vue&type=style&index=0&id=097b7b61&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports